import axios from 'axios'
import {attachAuthInterceptors} from '../../modules/auth/core/authInterceptors'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

attachAuthInterceptors(axiosInstance, {refreshOn402: true})

export default axiosInstance
